<template>
  <ProjectScaffold :loading="loadingCurrentProjet ||loadingProjects">
    <div class="form-wrapper" v-if="!loadingProjects">
      <p class="title">General info</p>
      <form>
        <div class="inputs" id="field-name">
          <ts-form-item label="Project name" :validation="$v.form.name">
            <div class="flex project-name" style="color: #6d7587">
              <div class="date">{{ projectDate }}</div>
              <div class="project-brand">{{ projectBrand }}</div>
              <ts-input v-model.lazy="$v.form.name.$model" :disabled="loading"></ts-input>
            </div>
          </ts-form-item>
          <div class="errors-item" v-show="hasError('name')">
            <p class="">
              This project name already exists
              <!-- {{ this.getError('name') }} -->
            </p>
          </div>
          <ts-form-item label="Project type" :validation="$v.form.projectType" class="dropdown">
            <MultiSelectionDropdown
              placeholder="Select a project type"
              :max-items="1"
              :width="378"
              size="large"
              :options="projectTypes"
              :read-only-single-option="false"
              v-model.lazy="$v.form.projectType.$model"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Partner" :validation="$v.form.partner" class="dropdown" v-if="shouldSelectPartner">
            <MultiSelectionDropdown
              placeholder="Select a partner"
              :max-items="1"
              :width="378"
              size="large"
              :options="partners"
              :read-only-single-option="false"
              v-model.lazy="$v.form.partner.$model"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Program" :validation="$v.form.program" class="dropdown" v-if="shouldSelectProgram">
            <MultiSelectionDropdown
              placeholder="Select a program"
              :max-items="1"
              :width="378"
              size="large"
              :options="programs"
              :read-only-single-option="false"
              v-model.lazy="$v.form.program.$model"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Destination platform (optional)" :validation="$v.form.platform" class="dropdown">
            <MultiSelectionDropdown
              placeholder="Select a destination platform"
              :width="378"
              size="large"
              :options="platforms"
              :read-only-single-option="false"
              v-model.lazy="$v.form.platform.$model"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Production type" :validation="$v.form.productionType" class="dropdown">
            <MultiSelectionDropdown
                placeholder="Select a production type"
                :max-items="1"
                :width="378"
                size="large"
                :options="productionTypes"
                :read-only-single-option="false"
                v-model.lazy="$v.form.productionType.$model"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Brand name" :validation="$v.form.brands" class="dropdown">
            <MultiSelectionDropdown
              placeholder="Select a brand"
              text-filter
              size="large"
              :max-items="2"
              :width="378"
              :options="filteredBrands"
              v-model.lazy="$v.form.brands.$model"
              @selected="onBrandsSelected"
              @reset="onBrandsReset"
              @saved="onBrandsSaved"
            >
              <template v-slot:header="{ selectOptionHandler, selectable }">
                <form action="" @submit.prevent="createBrand(selectOptionHandler)" class="brand-form" v-if="selectable">
                  <input
                    type="text"
                    class=""
                    placeholder="Add a brand : type the new brand name here"
                    v-model="brandInput"
                  />
                </form>
              </template>
            </MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Group" :validation="$v.form.groupSelected" class="dropdown">
            <MultiSelectionDropdown
              placeholder="Enter the group name"
              text-filter
              :max-items="1"
              style="margin-top: 10px;"
              :width="378"
              size="large"
              :options="filteredGroups"
              :read-only-single-option="false"
              v-model.lazy="$v.form.groupSelected.$model"
              class="project-status-select"
              @selected="onGroupSelected"
              @reset="onGroupReset"
              @saved="onGroupSaved"
            >
              <template v-slot:header="{ selectOptionHandler, selectable }">
                <form action="" @submit.prevent="createGroup(selectOptionHandler)" class="brand-form"
                      v-if="selectable">
                  <input
                    type="text"
                    class=""
                    placeholder="Add a group : type the new group name here"
                    v-model="groupInput"
                  />
                </form>
              </template>
            </MultiSelectionDropdown>
          </ts-form-item>

          <ts-form-item label="Industry" :validation="$v.form.industry" class="dropdown">
            <MultiSelectionDropdown
                placeholder="Select industry"
                :max-items="1"
                :width="378"
                size="large"
                :options="industryTypes"
                :read-only-single-option="false"
                v-model.lazy="$v.form.industry.$model"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Country" :validation="$v.form.country" class="dropdown">
            <MultiSelectionDropdown
                placeholder="Select a country"
                :max-items="1"
                :width="378"
                size="large"
                :options="regions"
                :read-only-single-option="false"
                v-model.lazy="$v.form.country.$model"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Due date (optional)" :validation="$v.form.dueDate" class="dropdown">
            <DatePickerDropdown
              placeholder="Select a due date"
              mode="single"
              size="large"
              :width="378"
              v-model.lazy="$v.form.dueDate.$model"
            ></DatePickerDropdown>
          </ts-form-item>
          <ts-form-item label="Status" :validation="$v.form.statuses" class="dropdown">
            <MultiSelectionDropdown
              size="large"
              :max-items="1"
              :width="378"
              :options="statusOptions"
              v-model.lazy="$v.form.statuses.$model"
            ></MultiSelectionDropdown>
          </ts-form-item>
          <ts-form-item label="Folder" :validation="$v.form.folder">
            <MultiSelectionDropdown
              placeholder="Please select a folder"
              :max-items="1"
              :textFilter="true"
              :width="378"
              size="large"
              :options="folders"
              :read-only-single-option="false"
              v-model.lazy="form.foldersSelected"
            >
            </MultiSelectionDropdown>
          </ts-form-item>
          <div class="actions">
            <ts-button :loading="loading" @click="handleSubmit">Save</ts-button>
          </div>
        </div>
      </form>
    </div>
  </ProjectScaffold>
</template>

<style lang="scss" scoped>
.brand-form {
  width: 100%;
  input {
    &::placeholder {
      color: #39c88c !important;
    }
    &:-moz-placeholder {
      color: #39c88c !important;
    }
    &:-webkit-input-placeholder {
      color: #39c88c !important;
    }
    color: #39c88c;
    width: 100%;
    padding: 5px 10px;
    // color: #6d7587;
    border-top: solid 1px rgba(0, 0, 0, 0.1);
    border-bottom: solid 1px rgba(0, 0, 0, 0.1);
    &:focus {
      outline: 0;
    }
  }
}
.errors-item {
  font-size: 0.85rem;
  margin-top: -10px;
  color: red;
}
.project-name {
  display: flex;
  align-items: center;
  justify-content: space-around;
  .date {
    padding: 0.5rem;
    &::after {
      content: '-';
      margin-left: 10px;
      margin-right: 10px;
    }
  }
  .project-brand {
    padding: 0.2rem;
    &::after {
      content: '-';
      margin-left: 10px;
      margin-right: 10px;
    }
  }
}
.form-wrapper {
  width: 378px;
  margin: 0 auto;
}

.icon {
  text-align: center;
  margin-bottom: 12px;
}

.title {
  font-family: Roboto;
  font-size: 24px;
  color: #6d7587;
  text-align: center;
  margin-bottom: 28px;
}

.message {
  font-family: Roboto;
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
  color: #6d7587;
}

.inputs {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dropdown {
  margin: 10px 0;
}

.actions {
  margin-top: 20px;
}
</style>

<script>
import { mapState, mapActions } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { parseISO } from 'date-fns';

import ProjectScaffold from '../ProjectScaffold.vue';
import MultiSelectionDropdown from '@/components/inputs/MultiSelectionDropdown.vue';
import DatePickerDropdown from '@/components/inputs/DatePickerDropdown.vue';

import projectViewHelpers from '@/mixins/projectViewHelpers';

export default {
  mixins: [projectViewHelpers],
  components: {
    ProjectScaffold,
    MultiSelectionDropdown,
    DatePickerDropdown
  },
  data() {
    return {
      loading: false,
      newFolder: null,
      errors: {},
      brandInput: null,
      newBrands: [],
      group: [],
      groupInput: null,
      form: {
        name: '',
        parentProjects: [],
        brands: [],
        dueDate: null,
        projectType: [],
        productionType: [],
        partner: [],
        foldersSelected: [],
        country: [],
        folder: null,
        groupSelected: [],
        program: [],
        platform: [],
        statuses: ['delivered']
      }
    };
  },
  computed: {
    ...mapState('workflow', {
      loadingCurrentProjet: state => state.currentProject.loading,
      project: state => state.currentProject.value,
      statusOptions: state => state.statuses.items,
      brandOptions: state => state.brandsManual.items,
      loadingProjects: state => state.myProjects.loading,
      projectOptions: state => state.myProjects.items,
      projectTypes: state => state.myProjects.options.projectTypes,
      productionTypes: state => state.myProjects.options.productionTypes,
      partners: state => state.myProjects.options.partners,
      groups: state => state.myProjects.options.groups,
      programs: state => state.myProjects.options.programs,
      platforms: state => state.myProjects.options.platforms,
      folders: state => state.myProjects.items,
      industryTypes: state => state.industryTypes.items.map(b => ({...b, _id: b.id, id: b.slug})),
      regions: state => state.regions.items.map(b => ({...b, _id: b.id, id: b.slug})),
    }),
    filteredBrands() {
      return [].concat(this.newBrands, this.brandOptions);
    },
    shouldSelectPartner() {
      return this.form.projectType[0] == 'partner';
    },
    shouldSelectProgram() {
      return ['facebook', 'tf1'].includes(this.form.partner[0]);
    },
    projectOptions() {
      return this.folders.reduce((acc, value) => [].concat(acc, value.projects), []);
    },
    projectDate() {
      const date = new Date();
      return ('' + date.getUTCFullYear()).slice(-2) + '' + ('0' + (date.getMonth() + 1)).slice(-2);
    },
    projectBrand() {
      const brands = this.brandOptions.filter(b => this.form.brands.includes(b.id));
      return brands.length == 0 ? 'Brand' : brands.map(b => b.name).join(' X ');
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      folder: {
        required
      },
      parentProjects: {},
      brands: {
        required
      },
      dueDate: {},
      projectType: {
        required
      },
      productionType: {},
      program: {
        required: requiredIf(vm => ['facebook', 'tf1'].includes(vm.partner[0]))
      },
      platform: {},
      partner: {
        required: requiredIf(vm => vm.projectType[0] == 'partner')
      },
      groupSelected: {},
      statuses: {
        required
      },
      status: {
        required
      },
      country: {},
      industry: {
        required
      },
    }
  },
  methods: {
    ...mapActions('workflow', ['fetchBrandsManual', 'fetchMyProjects', 'updateCurrentProjectGeneralInfo', 'fetchProjectOptions', 'fetchRegions', 'fetchIndustryTypes']),
    initForm() {
      this.form = {
        name: this.project.originalName,
        parentProjects: this.project.parentProject ? [this.project.parentProject.id] : [],
        brands: this.project.brandsManual ? this.project.brandsManual.map(b => b.id) : [],
        dueDate: this.project.dueDate ? parseISO(this.project.dueDate) : null,
        statuses: [this.project.status],
        projectType: this.project.projectType ? [this.project.projectType] : [],
        productionType: this.project.productionType ? [this.project.productionType] : [],
        folder: this.project.folder_id,
        country: this.project.country ? [this.project.country] : [],
        group: [this.project.group],
        groupSelected: [this.project.group],
        industry: [this.project.industry],
        foldersSelected: [this.project.folder_id],
        partner: this.project.partner ? [this.project.partner] : [],
        program: this.project.program ? [this.project.program] : [],
        platform: this.project.platform ? this.project.platform : []
      };
    },
    async handleSubmit() {
      if (this.form.foldersSelected.length > 0) {
        this.form.folder = this.form.foldersSelected[0];
      }
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$nextTick(() => {
          const errorMessage = document.querySelector('.error-message');
          errorMessage && errorMessage.parentNode.scrollIntoView({ behavior: 'smooth' });
        });
      }
      this.loading = true;
      try {
        await this.updateCurrentProjectGeneralInfo({
          name: this.form.name,
          parentProjectId: this.form.parentProjects ? this.form.parentProjects[0] : undefined,
          brandIds: this.form.brands.filter(b => b > 0),
          newBrands: this.newBrands,
          newGroups: this.newGroups,
          dueDate: this.form.dueDate,
          status: this.form.statuses ? this.form.statuses[0] : undefined,
          projectType: this.form.projectType[0],
          productionType: this.form.productionType[0],
          folder: this.form.foldersSelected.length > 0 ? this.form.foldersSelected[0] : null,
          partner: this.form.partner[0],
          program: this.form.program[0],
          platform: this.form.platform,
          country: this.form.country[0],
          group: this.form.groupSelected ? this.form.groupSelected[0] : null,
          industry: this.form.industry[0]
        });
        if (this.newBrands.length > 0) {
          this.newBrands = [];
          this.fetchBrandsManual();
        }
      } catch (err) {
        if ('data' in err.response) {
          this.notifyErrors(err.response.data?.errors);
        }
      }
      this.loading = false;
    },
    onBrandsSelected() {},
    onBrandsReset() {},
    onBrandsSaved({ items }) {
      if (this.brandInput) {
        this.createBrand(id => {
          this.form.brands.push(id);
        });
      }

      this.newBrands = this.newBrands.filter(b => {
        return this.form.brands.includes(b.id);
      });
    },
    createBrand(selectionHandler) {
      const latest = this.newBrands.sort((a, b) => a.id - b.id)[0];

      const brand = {
        id: latest ? latest.id - 1 : 0,
        name: this.brandInput
      };

      this.brandInput = null;
      this.newBrands.push(brand);
      selectionHandler(brand.id, true);
    },
    onGroupSelected() {
    },
    onGroupReset() {
    },
    onGroupSaved({items}) {
      if (this.groupInput) {
        this.createGroup(id => {
          this.groups.push(id);
        });
      }

      this.newGroups = this.newGroups.filter(b => {
        return this.groups.includes(b.id);
      });
    },
    notifyErrors(errors) {
      if (!errors) return;
      if ('name' in errors) {
        this.errors.name = errors.name;
        document.querySelector('#field-name').scrollIntoView({ behavior: 'smooth' });
      }
    },
    hasError(key) {
      return key in this.errors && this.errors[key];
    },
    getError(key) {
      return this.hasError(key) ? this.errors[key][0] : null;
    },
    createGroup(selectionHandler) {
      const latest = this.newGroups.sort((a, b) => a.id - b.id)[0];

      const group = {
        id: latest ? latest.id - 1 : 0,
        name: this.groupInput
      };

      this.groupInput = null;
      this.newGroups.push(group);
      selectionHandler(group.id, true);
    }
  },
  mounted() {
    if (this.project) {
      this.initForm();
    }
    this.fetchBrandsManual();
    this.fetchMyProjects();
    this.fetchProjectOptions();
    this.fetchIndustryTypes();
    this.fetchRegions();
  },
  watch: {
    'form.projectType': {
      handler(value) {
        if (value[0] != 'partner') {
          this.form.partner = [];
        }
      }
    },
    project(project) {
      project && this.initForm();
    },
    'form.partner': {
      handler(value) {
        if (!['facebook', 'tf1'].includes(value[0])) {
          this.program = [];
        }
      }
    }
  }
};
</script>
